import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-import-contact-list',
  templateUrl: './import-contact-list.component.html',
  styleUrls: ['./import-contact-list.component.scss']
})
export class ImportContactListComponent implements OnInit {
  displayedColumns: string[] = ['select', 'name', 'email'];
  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);



  constructor(
    public _matDialogRef: MatDialogRef<ImportContactListComponent>,
    @Inject(MAT_DIALOG_DATA) public _data,
  ) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this._data.contactList);

    console.log("data in the on it ", this._data.contactList);

  }

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  // }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  onSubmit() {
    console.log("hello in import contact list", this.selection);

    const selectedUsers = this.selection.selected.map(user => user.id);
    console.log('Selected users:', selectedUsers);
    this._matDialogRef.close(selectedUsers);
  }
}